module.exports = __webpack_public_path__ + "static/media/dont_sweat_details.7dd7de91.svg";